<div class="relative min-w-0" [class.inline-block]="variant() === 'inline'">
  <button
    #trigger
    type="button"
    class="flex items-center gap-2 min-w-0"
    [class]="triggerClasses()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="'listbox'"
    [disabled]="isDisabled()"
    (click)="toggle()"
  >
    <span
      class="truncate min-w-0"
      [class.text-text-tertiary]="!hasSelection() && variant() === 'form'"
    >{{ selectedLabel() }}</span>
    <span
      class="material-symbols-outlined text-[18px] shrink-0 text-text-tertiary transition-transform"
      [class.rotate-180]="isOpen()"
      aria-hidden="true"
    >expand_more</span>
  </button>

  @if (isOpen()) {
    <div
      class="fixed inset-0 z-10"
      (click)="onBackdropClick()"
      aria-hidden="true"
    ></div>
    <ul
      #panel
      role="listbox"
      class="fixed z-20 max-h-60 overflow-y-auto bg-white rounded-lg border border-border-medium shadow-lg py-1"
      [class.animate-slide-in-bottom]="!flipped()"
      [class.animate-fade-in]="flipped()"
      [style.top.px]="panelPosition().top"
      [style.left.px]="panelPosition().left"
      [style.width.px]="panelPosition().width"
      [style.minWidth.px]="variant() === 'inline' ? 160 : panelPosition().width"
      (click)="onPanelClick()"
    >
      @for (opt of options(); track opt.value; let i = $index) {
        <li role="presentation">
          <button
            type="button"
            role="option"
            [class]="optionClasses(opt.value, i)"
            [attr.aria-selected]="selectedValue() === opt.value"
            (click)="selectOption(opt.value)"
            (mouseenter)="highlightedIndex.set(i)"
          >
            <span class="truncate">{{ opt.label }}</span>
          </button>
        </li>
      } @empty {
        <li class="px-4 py-2.5 text-sm text-text-tertiary">No options</li>
      }
      @if (actionLabel(); as label) {
        <li role="presentation" class="mt-1 border-t border-border-light pt-1">
          <button
            type="button"
            [class]="actionClasses()"
            (click)="runAction()"
            (mouseenter)="highlightedIndex.set(options().length)"
          >
            <span class="material-symbols-outlined text-[18px]" aria-hidden="true">{{ actionIcon() }}</span>
            <span class="truncate">{{ label }}</span>
          </button>
        </li>
      }
    </ul>
  }
</div>
